"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translationsParser = void 0;
class TranslationsParser {
    fromExternalTranslation(translations) {
        const processedTranslations = {};
        if (!translations || translations.length === 0) {
            return processedTranslations;
        }
        translations.reduce((acc, current) => {
            if (current.key) {
                acc[current.key] = current;
            }
            return acc;
        }, processedTranslations);
        return processedTranslations;
    }
}
const translationsParser = new TranslationsParser();
exports.translationsParser = translationsParser;
